import BaseNode from './BaseNode';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import { colors } from '../../styles';

const BranchNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Ramificação" accent={colors.primary.blue} icon={<CallSplitIcon />} />
);

export default BranchNode;
